import { RouteRecordRaw } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireAuthenticated } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration, checkSitterOnboarding } from '@/router/guards/completionGuards';
import { redirectIfEmailVerificationRequiredForParentInteraction } from '@/router/guards/emailVerificationGuard';
import MessagesView from '@/apps/messages/MessagesView.vue';

// Variant B blocks message-center entry for unverified sitters (nav tile stays visible).
// Send-time enforcement in MessagesView.handleSend remains as defense in depth.
const messagingAccessGuards = combineGuards([
  requireAuthenticated,
  checkPremiumParentRegistration,
  checkSitterOnboarding,
  redirectIfEmailVerificationRequiredForParentInteraction,
]);

const messagesRoutes: RouteRecordRaw[] = [
  {
    path: '/messages',
    name: 'Messages',
    component: MessagesView,
    beforeEnter: messagingAccessGuards,
    meta: { shouldHideFooter: true },
  },
];

export default messagesRoutes;
